export default (loading, type) => {
  if (loading && type) {
    return !!loading.filter((item) => item.type === type).length;
  }

  return false;
};
